import { useEffect } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { useEligibleForJsmGrowth220JsmJpdWacSignup } from "./controllers";
import { Growth220OnboardingWizard } from "./growth-220-onboarding-wizard";
import { ProvisioningApiProvider } from "./growth-220-onboarding-wizard/provisioning-api-provider";
import { JiraProvisioningWithOnboardingWizard } from "./jira-onboarding-wizard";

export const OnboardingWizard = () => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { userEligibleForJsmGrowth220JsmJpdWacSignup } =
        useEligibleForJsmGrowth220JsmJpdWacSignup();

    useEffect(() => {
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "onboardingWizardScreen",
            attributes: {
                isJsmGrowth220Enabled: Boolean(
                    userEligibleForJsmGrowth220JsmJpdWacSignup
                ),
                reactComponent: "OnboardingWizard"
            }
        }).fire();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (userEligibleForJsmGrowth220JsmJpdWacSignup) {
        return (
            <ProvisioningApiProvider>
                <Growth220OnboardingWizard />
            </ProvisioningApiProvider>
        );
    }
    return <JiraProvisioningWithOnboardingWizard />;
};
